import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router';
import { useFlowium } from '../client/FlowiumContext';
import Modal from '../components/Modal';

const PlanSuccess = () => {
  const [message, setMessage] = useState('Processing your subscription...');
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { client } = useFlowium();

  useEffect(() => {
    let cancelled = false;
    let redirectTimer: number | undefined;

    const verifySubscription = async () => {
      const sessionId = searchParams.get('session_id');
      if (!sessionId) {
        if (!cancelled) setMessage('No session ID provided');
        return;
      }

      try {
        await client.verifySubscription(sessionId);
        if (cancelled) return;
        setMessage('Your subscription was successful!');
        redirectTimer = window.setTimeout(() => navigate('/browser'), 2000);
      } catch (error) {
        if (!cancelled) {
          setMessage('Failed to verify subscription. Please contact support.');
        }
      }
    };

    verifySubscription();
    return () => {
      cancelled = true;
      if (redirectTimer !== undefined) window.clearTimeout(redirectTimer);
    };
  }, [searchParams, navigate, client]);

  return (
    <div className='flex flex-col items-center justify-center h-full min-h-[60vh]'>
      <Modal
        isOpen={true}
        onClose={() => navigate('/settings/plan')}
        title="Subscription status"
      >
        <div className='p-20 max-w-xl w-full flex flex-col items-center justify-center'>
          <span className='text-md font-normal text-center w-full'>{message}</span>
        </div>
      </Modal>
    </div>
  );
};

export default PlanSuccess;
